var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", [_c("el-form-item", {
    attrs: {
      label: "服务器ID：",
      "label-width": "120px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "217px",
      height: "38px"
    },
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.formData.serverId,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "serverId", $$v);
      },
      expression: "formData.serverId"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "工会ID：",
      "label-width": "120px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "217px",
      height: "38px"
    },
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.formData.unionId,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "unionId", $$v);
      },
      expression: "formData.unionId"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "修改类别：",
      "label-width": "120px"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "217px"
    },
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _vm.value == "type1" ? _c("el-form-item", {
    attrs: {
      label: "工会会长ID：",
      "label-width": "120px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "217px",
      height: "38px"
    },
    model: {
      value: _vm.formInfoType1.new_master_id,
      callback: function callback($$v) {
        _vm.$set(_vm.formInfoType1, "new_master_id", _vm._n($$v));
      },
      expression: "formInfoType1.new_master_id"
    }
  })]], 2) : _vm._e(), _vm.value == "type2" ? _c("el-form-item", {
    attrs: {
      label: "工会名称：",
      "label-width": "120px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "217px",
      height: "38px"
    },
    model: {
      value: _vm.formInfoType2.union_name,
      callback: function callback($$v) {
        _vm.$set(_vm.formInfoType2, "union_name", $$v);
      },
      expression: "formInfoType2.union_name"
    }
  })]], 2) : _vm._e(), _vm.value == "type3" ? _c("el-form-item", {
    attrs: {
      label: "工会公告：",
      "label-width": "120px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "217px",
      height: "38px"
    },
    model: {
      value: _vm.formInfoType3.notice,
      callback: function callback($$v) {
        _vm.$set(_vm.formInfoType3, "notice", $$v);
      },
      expression: "formInfoType3.notice"
    }
  })]], 2) : _vm._e(), _c("el-form-item", {
    staticStyle: {
      "margin-left": "40%"
    }
  }, [[_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.confirmbtn();
      }
    }
  }, [_vm._v("保存")])]], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };